import React, { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import Profile from 'assets/icon/Profile-logo.png';
export default function ShowId(props) {
  const onchangeform = () => {
    props.changeFormToEdit(true);
  };

  // console.log('ShowId',props.data);

  return (
    <>
      <Row className="justify-content-center ">
        <Col xs={12} sm={12} md={12} lg={6}>
          <Row className="">
            <Col lg={4}>
              <img width={150} height={150} src={props.data && props.data.Avatar ? props.data.Avatar :Profile} />
            </Col>
            <Col lg={8}>
              <Row className="justify-content-center">
                <Col xs={12} lg={12}>
                  <Row className="justify-content-center set-row-Showid">
                    <Col xs={3} md={2} lg={4} className="text-left">
                      <Form.Label>ชื่อ-นามสกุล</Form.Label>
                    </Col>
                    <Col xs={4} md={3} lg={6} className="text-left">
                      <p>{props.data.Employee && props.data.Employee.fullname}</p>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} lg={12}>
                  <Row className="justify-content-center set-row-Showid">
                    <Col xs={3} md={2} lg={4} className="text-left">
                      <Form.Label>ชื่อผู้ใช้</Form.Label>
                    </Col>
                    <Col xs={4} md={3} lg={6} className="text-left">
                      <p>{props.data.Username}</p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={7} className="d-flex justify-content-center">
                  <Button
                    type="button"
                    className="button-edit"
                    onClick={onchangeform}
                  >
                    แก้ไข
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col></Col>
      </Row>
    </>
  );
}
